import styled from "styled-components";
import { AppBar, MenuItem } from "@mui/material";
import List from "@mui/material/List";

export const AppGridWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
`;

export const AppContainer = styled.div`
  display: flex;
  height: calc(100% - 64px);
  width: 100%;
  overflow-y: auto;
  overflow-x: scroll;
  padding-bottom: 120px;

  &::-webkit-scrollbar {
    display:block;
    width: 10px;
  }

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #6750A4;
    border-radius: 10px;
    // background-clip: padding-box;
    border: 2px solid transparent;
  }
  &::-webkit-scrollbar-track {
    background: linear-gradient(0deg,rgba(103,80,164,0.05),rgba(103,80,164,0.05)),#FFFBFE;
    border-radius: 10px;
    opacity:0.7;
    // box-shadow: inset 0px 0px 5px white;
  }
`;

export const UnauthPageWarp = styled.div`
  padding: 100px 20px;
`;

export const MuiAppBar = styled(AppBar)`
  &.MuiPaper-root {
    position: relative;
  }
  .MuiToolbar-root {
    background-color: #6750a4;
    height: 64px;
    .MuiToolbar-root {
      min-height: 64px;
    }
  }
`;

export const MuiMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    height: 56px;
    border-radius: 0 50px 50px 0;
  }
  &.MuiMenuItem-root:hover {
    background: linear-gradient(
        0deg,
        rgba(103, 80, 164, 0.05),
        rgba(103, 80, 164, 0.05)
      ),
      #fffbfe;
  }
  &.Mui-selected {
    background: linear-gradient(
        0deg,
        rgba(103, 80, 164, 0.05),
        rgba(103, 80, 164, 0.05)
      ),
      #fffbfe !important;
  }
`;

export const NameBadge = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  margin-right: -24px;
  display: block;
  font-size: 12px;
`;

export const MenuList = styled(List)({
  // selected and (selected + hover) states
  "&& .Mui-selected, && .Mui-selected:hover": {
    backgroundColor: "rgba(103, 80, 164, 0.05)",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    "&, & .MuiListItemIcon-root": {
      color: "#6750A4",
    },
  },
  // hover states
  "& .MuiListItem-root:hover": {
    backgroundColor: "rgba(103, 80, 164, 0.05)",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    "&, & .MuiListItemIcon-root": {
      color: "#6750A4",
    },
  },
});

export const RouteBox = styled.div`
  width: calc(1920px - 256px);
  padding-left: 48px;
  padding-right: 48px;
  height: auto;
`;
